import { useTranslation } from "react-i18next";

export default function ProgressBar({ raised, goal, dark = false }) {
  const { t } = useTranslation();
  const pct = Math.min(100, Math.round((raised / goal) * 100));

  return (
    <div
      role="progressbar"
      aria-label={t("spenden.progressLabel")}
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      className={`tl-progress-track${dark ? " is-dark" : ""}`}
    >
      <div className="tl-progress-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
